import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'grandparents_lifespan'

const answers: AnswerType[] = [
  {
    emoji: '⏱️‍',
    title: 'pages.onboarding.grandparentsLifespan.options.under70',
    value: 'under-70',
  },
  {
    emoji: '🕰️️‍',
    title: 'pages.onboarding.grandparentsLifespan.options.70to79',
    value: '70-79',
  },
  {
    emoji: '🎂',
    title: 'pages.onboarding.grandparentsLifespan.options.80to89',
    value: '80-89',
  },
  {
    emoji: '🏆️‍',
    title: 'pages.onboarding.grandparentsLifespan.options.90plus',
    value: '90-plus',
  },
]

export default function GrandparentsLifespanPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && answers.some((answer) => answer.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const value = input.value

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How long did your grandparents live?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.grandparentsLifespan.heading"
      onSubmit={onSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
